export const optionHeight = {
  groupHeading: 36,
  user: 40,
  userDescription: 56,
  tag: 46,
  tagDescription: 56,
  basic: 36,
  allOptions: 56,
};
